import React from 'react';

const LegendMap = () => {
    const items = [
        { color: '#2E8B57', label: 'Light' },
        // { color: '#ffff00', label: 'Moderate' },
        { color: '#ffff00', label: 'Severe' },
        // { color: '#FF8C00', label: 'Severe' },
        { color: '#FF8C00', label: 'Lightning' },
        { color: '#ff0000', label: 'High-density lightning' },
        { color: '#800080', label: 'Overshoot' },
    ];
  
    return (
      <div style={{ 
        position: 'absolute', 
        bottom: '5px', 
        right: '6px', 
        backgroundColor: 'rgba(255, 255, 255, 0.8)', 
        padding: '2px', 
        borderRadius: '5px', 
        boxShadow: '0 0 15px rgba(0, 0, 0, 0.2)', 
        zIndex: 0 
      }}>
        {/* <h style={{alignItems:'center', alignText:'center'}}>Legend</h> */}
        <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
          {items.map((item, index) => (
            <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontSize:'0.65em' }}>
              <span style={{
                display: 'inline-block',
                width: '7.5px',
                height: '7.5px',
                border: '1px solid black',
                backgroundColor: item.color,
                marginRight: '5px'
              }}></span>
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  
  export default LegendMap;